import { z } from "zod";

export const sirenOrSiretSchema = z.coerce
	.string({
		required_error: "Veuillez saisir le numéro SIREN ou SIRET.",
		invalid_type_error: "Veuillez saisir le numéro SIREN ou SIRET.",
	})
	.regex(
		/^\d+$/,
		"Le numéro SIREN ou SIRET doit contenir uniquement des chiffres.",
	)
	.refine((val) => val.length === 9 || val.length === 14, {
		message:
			"Le numéro SIREN doit contenir 9 chiffres ou le numéro SIRET doit contenir 14 chiffres.",
	});
